import { Component, Injector, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UiStateService} from '../../../services/ui-state.service';
import {NationalTeamsService} from '../../../services/national-teams.service';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'change-national-team-dialog',
    templateUrl: './change-national-team-dialog.component.html',
    styleUrls: ['./change-national-team-dialog.component.scss']
})
export class ChangeNationalTeamDialogComponent extends BaseDialogComponent implements OnInit {
    constructor(
        public activeModal: NgbActiveModal,
        public nationalTeamsService: NationalTeamsService,
        public uiStateService: UiStateService,
        injector: Injector
    ) {
        super(injector);
    }

    onNationalTeamSelect(nationalTeam) {
        this.nationalTeamsService.setNationalTeam(nationalTeam);
        this.activeModal.close();
    }

    ngOnInit() {}
}
